import DatasetAttributeGroup from '../dataset_attribute_group';
import DimensionAttribute from './dimension_attribute';
import {ATTRIBUTES} from "../../../../../../utils/query_utils";

export default class DimensionsGroup extends DatasetAttributeGroup {
    placeholder = 'Campaign';
    type = ATTRIBUTES.DIMENSION;
    AttributeComponent = DimensionAttribute
}
